export default [
  {
    path: '/recommend/index',
    name: 'Index',
    component: () => import('@/views/recommend/index'),
    meta: {
      title: '同学圈精华集锦-高考直通车'
    }
  },
  {
    path: '/recommend/special',
    name: 'Special',
    component: () => import('@/views/recommend/special'),
    meta: {
      title: '同学圈精华集锦-高考直通车'
    }
  },
  {
    path: '/recommend/search',
    name: 'Search',
    component: () => import('@/views/recommend/search'),
    meta: {
      title: '同学圈精华集锦-高考直通车'
    }
  }
]
